import React from "react";
import LycaSimBanner from "../../reusable/LycaSimBanner";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import AnyQuestions from "../../reusable/AnyQuestions";
import BuySimSubNavi from "../../reusable/BuySimSubNavi";
import BuySimCartMain from "./BuySimCartMain";

class BuySimCart extends React.Component {
    render(){
        return(
            <div>
                <LycaSimBanner />
                <BuySimSubNavi />
                <BuySimCartMain />
                <AnyQuestions />
                <StayTouch />
            </div>
        );
    }
}

export default layoutWrapper(BuySimCart);



// WEBPACK FOOTER //
// ./src/pages/buysimCart/index.js